import { render } from "./InviteMemberDialog.vue?vue&type=template&id=4380ff2e"
import script from "./InviteMemberDialog.vue?vue&type=script&lang=js"
export * from "./InviteMemberDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__